import type { App } from 'vue';
import input from '@/directives/input';
import button from '@/directives/button';

export default function setGlobDirectives(app: App<Element>) {
    app.directive('input', input);
    app.directive('button', button);
}
